import React, { forwardRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useAuth, useIntl } from 'hooks'
import { IconSettings, IconLogout, IconUserManual, IconUserOperator } from 'components/Zui/Icon'
import { Button, SectionDivider } from 'components/Zui'
import './index.css'

const UserProfileModal = (
    {
        onClose,
        onOpen,
        handleVesionOpen,
        handleLegalOpen,
        handlePrivacyOpen,
        handleTermsToUseOpen,
        handleImprintOpen,
        handleFossOpen,
    },
    ref
) => {
    const { t } = useIntl()
    const history = useHistory()
    const { pathname } = useLocation()
    const { isAuthorized, logout } = useAuth()

    const handleLogout = () => {
        history.replace(pathname, 'triggerLogout')
        logout()
    }

    const handleClosePopup = action => {
        onClose()
        action && action()
    }

    const menuItems = [
        {
            header: t('configuration'),
            items: [
                {
                    icon: <IconSettings />,
                    name: t('settings'),
                    onClick: isAuthorized && onOpen,
                },
            ],
        },
        {
            header: t('help'),
            items: [
                {
                    icon: <IconUserOperator />,
                    name: t('customer.support'),
                },
                {
                    icon: <IconUserManual />,
                    name: t('instructions.for.use'),
                },
            ],
        },
        {
            header: t('information'),
            items: [
                {
                    name: t('imprint'),
                    onClick: handleImprintOpen,
                },
                {
                    name: t('privacy.policy'),
                    onClick: handlePrivacyOpen,
                },
                {
                    name: t('terms.of.use'),
                    onClick: handleTermsToUseOpen,
                },
                {
                    name: t('legal.information'),
                    onClick: handleLegalOpen,
                },
                {
                    name: t('foss'),
                    onClick: handleFossOpen,
                },
                {
                    name: t('software.version'),
                    onClick: handleVesionOpen,
                },
            ],
        },
    ]

    const ProfileMenu = ({ data }) => {
        return data.map((menu, index) => (
            <div className="popup-menu" key={index}>
                <SectionDivider>
                    <div>{menu.header}</div>
                </SectionDivider>
                {menu.items.map((item, index) => (
                    <div
                        className="profile-menu-item"
                        key={index}
                        onClick={() => {
                            handleClosePopup(item.onClick)
                        }}
                    >
                        {item.icon && <div className="profile-menu-icon">{item.icon}</div>}
                        <div className="profile-menu-text">
                            <span>{item.name}</span>
                        </div>
                    </div>
                ))}
            </div>
        ))
    }

    return (
        <div className="user-profile-popup" ref={ref}>
            <div className="logout-wrapper">
                <div className="logout-button">
                    <Button
                        className="logout-button"
                        onClick={() => handleClosePopup(handleLogout)}
                    >
                        {t('logout')}
                        <IconLogout slot="icon" />
                    </Button>
                </div>
            </div>

            <div className="profile-menu-wrapper">
                <ProfileMenu data={menuItems} />
            </div>
        </div>
    )
}

export default forwardRef(UserProfileModal)
